import { Auth as aws } from 'aws-amplify';

export const getAuthToken = async () => {
  const session = await aws.currentSession();
  return session?.getIdToken?.()?.getJwtToken?.() || null;
};
